import { render, staticRenderFns } from "./DirfDetalhar.vue?vue&type=template&id=c63bfb00&"
import script from "./DirfDetalhar.vue?vue&type=script&lang=js&"
export * from "./DirfDetalhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports